(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero_image_slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lp-hero'))
  customElements.define(
    'lp-hero',
    class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track = this.querySelector('.lp-hero-track');
        this.slides = [...this.querySelectorAll('.lp-hero-slide')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.i = 0;
        this.paused = false;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        if (this.slides.length < 2) return;
        this.querySelector('.lp-hero-controls').hidden = false;
        this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.i - 1), {
          signal,
        });
        this.querySelector('[data-next]').addEventListener('click', () => this.go(this.i + 1), {
          signal,
        });
        this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i), { signal }));
        this.track.addEventListener(
          'scroll',
          () => {
            this.i = Math.round(this.track.scrollLeft / this.track.clientWidth);
            this.dots.forEach((d, i) => d.setAttribute('aria-pressed', String(i === this.i)));
          },
          { signal, passive: true },
        );
        this.track.addEventListener(
          'keydown',
          (e) => {
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
              e.preventDefault();
              this.go(this.i + (e.key === 'ArrowRight' ? 1 : -1));
            }
          },
          { signal },
        );
        this.querySelector('[data-pause]')?.addEventListener(
          'click',
          (e) => {
            this.paused = !this.paused;
            e.currentTarget.textContent = this.paused ? '▶' : 'Ⅱ';
            e.currentTarget.setAttribute(
              'aria-label',
              this.paused ? e.currentTarget.dataset.play : e.currentTarget.dataset.pauseLabel,
            );
          },
          { signal },
        );
        document.addEventListener(
          'shopify:block:select',
          (e) => {
            const slide = e.target.closest('.lp-hero-slide');
            if (slide && this.contains(slide)) {
              this.paused = true;
              this.go(this.slides.indexOf(slide));
            }
          },
          { signal },
        );
        if (this.dataset.autoplay === 'true')
          this.timer = setInterval(
            () => {
              const r = this.getBoundingClientRect();
              if (
                !this.paused &&
                !this.reduced.matches &&
                !document.hidden &&
                !this.matches(':hover') &&
                !this.contains(document.activeElement) &&
                r.bottom > 0 &&
                r.top < innerHeight
              )
                this.go(this.i + 1);
            },
            Number(this.dataset.delay) || 5000,
          );
      }
      go(i) {
        this.i = (i + this.slides.length) % this.slides.length;
        this.track.scrollTo({
          left: this.i * this.track.clientWidth,
          behavior: this.reduced.matches ? 'auto' : 'smooth',
        });
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.abort?.abort();
        this.ready = false;
      }
    },
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-sticky-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lp-sticky-offer-v3')) {
    customElements.define('lp-sticky-offer-v3', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.bar = this.querySelector('.lps3-bar');
        if (!this.bar) return;
        this.ready = true;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.button = this.bar.querySelector('.lps3-button');
        this.spacer = document.createElement('div');
        this.spacer.className = 'lps3-spacer';
        this.spacer.setAttribute('aria-hidden', 'true');
        document.body.append(this.spacer, this.bar);
        this.refresh = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        };
        window.addEventListener('scroll', this.refresh, { signal, passive:true });
        window.addEventListener('resize', this.refresh, { signal });
        document.addEventListener('shopify:section:load', this.refresh, { signal });
        document.addEventListener('shopify:section:unload', this.refresh, { signal });
        document.addEventListener('shopify:section:reorder', this.refresh, { signal });
        this.observer = new ResizeObserver(this.refresh);
        this.observer.observe(this.bar);
        this.button.addEventListener('click', event => {
          const target = this.getTarget();
          if (target) {
            event.preventDefault();
            const topBar = innerWidth >= 750 && this.bar.classList.contains('lps3-top');
            const offset = topBar ? this.bar.getBoundingClientRect().bottom + 16 : 24;
            const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
            window.scrollTo({ top:Math.max(0, scrollY + target.getBoundingClientRect().top - offset), behavior:reduced ? 'auto' : 'smooth' });
          } else if (!this.dataset.fallback) {
            event.preventDefault();
          }
        }, { signal });
        this.update();
      }
      getTarget() {
        const id = (this.dataset.target || 'offers').trim().replace(/^#/, '');
        return document.getElementById(id) || document.querySelector('lp-flex-product .lpf-wrap, lp-product-offer .lp-anchor');
      }
      update() {
        if (!this.isConnected) return;
        const target = this.getTarget();
        const fallback = this.dataset.fallback;
        this.button.setAttribute('aria-disabled', String(!target && !fallback));
        this.button.href = target ? '#' + target.id : fallback || '#';
        const notice = this.bar.querySelector('.lps3-notice');
        if (notice) notice.hidden = Boolean(target || fallback);
        const rect = target?.getBoundingClientRect();
        const offerVisible = rect && rect.top < innerHeight && rect.bottom > 0;
        const editing = this.dataset.editor === 'true';
        const delayed = scrollY < Number(this.dataset.delay || 0);
        const hideAtOffer = this.dataset.hideOffer === 'true' && offerVisible;
        this.bar.hidden = !editing && Boolean(delayed || hideAtOffer);
        const atBottom = innerWidth < 750 || !this.bar.classList.contains('lps3-top');
        this.spacer.style.height = !this.bar.hidden && atBottom ? this.bar.offsetHeight + 'px' : '0px';
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.abort?.abort();
        this.observer?.disconnect();
        if (this.bar) this.append(this.bar);
        this.spacer?.remove();
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lp-flex-product')) {
    customElements.define('lp-flex-product', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;

        this.abort = new AbortController();
        const signal = this.abort.signal;

        this.images = [...this.querySelectorAll('[data-image]')];
        this.thumbnails = [...this.querySelectorAll('[data-thumbnail]')];

        this.variants = JSON.parse(
          this.querySelector('[data-variant-data]')?.textContent || '[]'
        );

        this.picker = this.querySelector('[data-variant-picker]');
        this.variantInput = this.querySelector('[data-product-variant-id]');

        this.money = new Intl.NumberFormat(
          this.dataset.locale || 'en',
          {
            style: 'currency',
            currency: this.dataset.currency || 'USD'
          }
        );

        const thumbs = this.querySelector('.lpf-thumbnails');
        if (thumbs) thumbs.hidden = false;

        this.showImage(
          this.variants.find(
            variant => String(variant.id) ===
              (this.picker?.value || this.variantInput?.value)
          )?.image
        );

        this.thumbnails.forEach(button => {
          button.addEventListener(
            'click',
            () => this.showImage(button.dataset.thumbnail),
            { signal }
          );
        });

        this.picker?.addEventListener('change', () => {
          if (this.variantInput) {
            this.variantInput.value = this.picker.value;

            this.variantInput.dispatchEvent(
              new Event('change', { bubbles: true })
            );
          } else {
            this.updateVariant(this.picker.value);
          }
        }, { signal });

        this.variantInput?.addEventListener(
          'change',
          () => this.updateVariant(this.variantInput.value),
          { signal }
        );

        this.querySelectorAll('[data-open-drawer]').forEach(button => {
          const dialog = document.getElementById(
            button.dataset.openDrawer
          );

          if (!dialog || typeof dialog.showModal !== 'function') return;

          button.hidden = false;

          button.addEventListener(
            'click',
            () => dialog.showModal(),
            { signal }
          );

          dialog.querySelector('[data-close-drawer]').addEventListener(
            'click',
            () => dialog.close(),
            { signal }
          );

          dialog.addEventListener('click', event => {
            const rect = dialog.getBoundingClientRect();

            if (
              event.target === dialog &&
              (
                event.clientX < rect.left ||
                event.clientX > rect.right ||
                event.clientY < rect.top ||
                event.clientY > rect.bottom
              )
            ) {
              dialog.close();
            }
          }, { signal });
        });
      }

      showImage(id) {
        const selected = this.images.find(
          image => image.dataset.image === String(id)
        ) || this.images[0];

        if (!selected) return;

        this.images.forEach(image => {
          image.hidden = image !== selected;
        });

        this.thumbnails.forEach(button => {
          button.setAttribute(
            'aria-pressed',
            String(button.dataset.thumbnail === selected.dataset.image)
          );
        });
      }

      updateVariant(id) {
        const variant = this.variants.find(
          item => String(item.id) === String(id)
        );

        if (!variant) return;

        if (this.picker) {
          this.picker.value = String(variant.id);
        }

        this.querySelectorAll('[data-price]').forEach(price => {
          price.textContent = this.money.format(variant.price / 100);
        });

        this.querySelectorAll('[data-compare]').forEach(price => {
          price.hidden = variant.compare <= variant.price;
          price.textContent = this.money.format(variant.compare / 100);
        });

        const button = this.querySelector('[data-native-buy]');

        if (button) {
          button.disabled =
            !variant.available ||
            this.dataset.requiresPlan === 'true';

          button.textContent = variant.available
            ? button.dataset.label
            : this.dataset.soldOut;
        }

        if (variant.image) {
          this.showImage(variant.image);
        }
      }

      disconnectedCallback() {
        this.querySelectorAll('dialog[open]').forEach(dialog => {
          dialog.close();
        });

        this.abort?.abort();
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
